import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IUniversalBenefits } from '@core/models/modals';
import { MbDialogHeader, MbDialogBody, MbIcon, MB_DIALOG_DATA } from '@am/moebius';
import { DialogWrapperComponent } from '@modals/dialog-wrapper/dialog-wrapper.component';

@Component({
  selector: 'app-modal-universal-benefits-detail',
  standalone: true,
  imports: [CommonModule, MbDialogHeader, MbDialogBody, MbIcon],
  templateUrl: './universal-benefits-detail.component.html',
  styleUrls: ['./universal-benefits-detail.component.scss'],
})
export class ModalUniversalBenefitsDetailComponent
  extends DialogWrapperComponent
  implements OnInit
{
  constructor(@Inject(MB_DIALOG_DATA) public dialogData: IUniversalBenefits) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
